<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout
        row
        wrap
        class="mx-0 mt-3"
        justify-center
      >
        404
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/NotFoundPage.vue